import deviceTracker from "device-tracker";
import createLsm from "lsm";


// Pi-stacja plugins system.
const pie = (function piePlugin() {

  function plugin(pluginCallback) {
    window.piePlugins = window.piePlugins || [];
    window.piePlugins.push(pluginCallback);
  }

  function init(userConfig) {
    let config = {};

    try {
      config = userConfig();
      config.lsm = createLsm();
      config.device = deviceTracker;
      config.$ = document.querySelector.bind(document);
      config.$$ = selector => Array.from(document.querySelectorAll(selector));
    }

    catch (error) {
      console.error("Pistacja Error: Problems with initial configuration.\n", error);
    }

    window.piePlugins = window.piePlugins || [];
    window.piePlugins.forEach(async callPlugin => {

      if (typeof callPlugin !== "function") {
        throw new Error("Plugin need to be a function");
      }

      try {
        await callPlugin(config);
      }

      catch (error) {
        console.error(`Plugin ${callPlugin.name} erron.\n`, error);
      }

    });
    delete window.piePlugins;
  }

  return { plugin, init };
})();

export default pie;
